﻿var mmsystem = mmsystem || {};

//Node imports
//mmsystem.core = require('mmsystem-core');
//var $ = jQuery = mmsystem.core.$;

//console.log("mmsystem.utilities.js ....");

mmsystem.utilities = {

    EnterKeySubmit: function (field, btnName) {

        if ($(field).length) {

            $(field).keypress(function (e) {

                if (e.keyCode === '13') {
                    __doPostBack(btnName, '');
                    return false;
                }
            });
        }
    },

    GetLocalisedStringValue: function search(localisedStringKey, myArray) {
        myArray = typeof myArray !== "undefined" ? myArray : new Array();
        for (var i = 0; i < myArray.length; i++) {
            if (myArray[i].Key === localisedStringKey) {
                return myArray[i].Value !== null ? myArray[i].Value : "";
            }
        }
        return "";
    },

    GetLocalisedStringValueWithJoinedLanguage: function search(localisedStringKey, myArray) {
        myArray = typeof myArray !== "undefined" ? myArray : new Array();
        for (var i = 0; i < myArray.length; i++) {
            if (myArray[i].Key === localisedStringKey + myArray[i].Language) {
                return myArray[i].Value !== null ? myArray[i].Value : "";
            }
        }
        return "";
    },

    ScrollToSection: function (sectionId) {
        var section = $('#' + sectionId);
        $('html, body').animate({
            scrollTop: section.offset().top - 50
        }, 500, 'swing', function () {

        });
    },

    ScrollToErrorValidator: function (errorElement) {
        $('html, body').animate({
            scrollTop: errorElement.offset().top - 50
        }, 500, 'swing', function () {

        });
    },

    OverlayCloseEvent: function (overlayElement, ignoreElements) {
        $(document).on('click', overlayElement, function (e) {
            var hide = true;
            $.each(ignoreElements, function (key, value) {
                //alert(key + ": " + value);
                var ignoreElement = ignoreElements[key];
                //console.log(ignoreElement);
                //console.log($(e.target));
                if ($(e.target).parents(ignoreElement).length > 0) {
                    hide = false;
                }
            });

            if (hide)
                $(overlayElement).fadeOut();
        });
    },

    AjaxLoaderCover: function (containerClass, btnClass, coverColor, imagePath, imageSize, eventType) {
        var container = $('.' + containerClass);
        var cover;
        var btn;
        eventType = typeof eventType !== "undefined" ? eventType : 'click';

        if (container.length > 0) {
            container.css({ 'position': 'relative', 'float': 'left' });
            container.append('<span class="ajax-cover"></span>');
            cover = container.find('span.ajax-cover').hide();
            btn = container.find('.' + btnClass);
            btn.on(eventType, function () {
                $(this).closest('.' + containerClass).find('span.ajax-cover').show();
            });
            cover.css(
                {
                    'position': 'absolute',
                    'top': '0',
                    'left': '0',
                    'background-image': 'url("' + imagePath + '")',
                    'background-color': coverColor,
                    'background-size': imageSize,
                    'background-repeat': 'no-repeat',
                    'background-position': 'center',
                    'width': '100%',
                    'height': '100%'
                });
            btn.css(
                {
                    'display': 'inline-block'
                });
        }

        this.AjaxLoaderCover.Hide = function () {
            if (cover.length > 0)
                cover.hide();
        };


        return this.AjaxLoaderCover;
    },

    GetUrl: function () {
        return window.location;
    },

    GetBaseUrl: function () {
        var Url = mmsystem.utilities.GetUrl();
        var baseUrl = Url.protocol + "//" + Url.host; // + "/" + Url.pathname.split('/')[1];
        return baseUrl;
    },

    RedirectToUrl: function (url) {
        window.location.replace(url);
    },

    RedirectToBaseNoCache: function () {
        mmsystem.utilities.RedirectToUrl(mmsystem.utilities.GetBaseUrl() + "?nocache=true");
    },

    ReloadLocationWithParams: function (params) {
        var url = window.location.href;
        for (var i = 0; i < params.length; i++) {
            if (url.indexOf('?') > -1) {
                url += '&' + params[i];
            } else {
                url += '?' + params[i];
            }
        }
        window.location.href = url;
    },

    RedirectToUrlTimer: function (url, milliSeconds, countDownElement) {

        var interval = 1000;

        var myIntervar = setInterval(function () {

            var element = $(countDownElement);
            // Get todays date and time
            //var now = new Date().getTime();

            // Find the distance between now an the count down date
            //var distance = milliSeconds - interval;

            // Time calculations for days, hours, minutes and seconds
            //var days = Math.floor(distance / (1000 * 60 * 60 * 24));
            //var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            //var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            var seconds = Math.floor((milliSeconds % (1000 * 60)) / 1000);
            element.html('You will be redirected in ' + seconds + 's ');
            // Display the result in the element with id="demo"
            //document.getElementById("demo").innerHTML = days + "d " + hours + "h "
            //+ minutes + "m " + seconds + "s ";

            // If the count down is finished, write some text 
            if (milliSeconds <= 0) {
                clearInterval(myIntervar);
                mmsystem.utilities.RedirectToUrl(url);
            }

            milliSeconds -= interval;

        }, interval);
    },

    DisplayPrice: function (price, currencyISO) {
        var currencySymbol = "";
        var priceString = "";
        price = parseFloat(price);

        if (isNaN(price)) {
            price = 0;
        }

        switch (currencyISO) {
            case "USD":
                currencySymbol = "$";
                priceString = currencySymbol + price.toFixed(2);
                break;
            case "GBP":
                currencySymbol = "£";
                priceString = currencySymbol + price.toFixed(2);
                break;
            case "EUR":
                currencySymbol = "€";
                priceString = currencySymbol + price.toFixed(2);
                break;
            case "PLN":
                currencySymbol = " zł";
                priceString = price.toFixed(2) + currencySymbol;
                break;
            default:
                currencySymbol = "$";
                priceString = currencySymbol + price.toFixed(2);
        }

        return priceString;
    },

    CamelizeString: function (text, separator) {

        // Assume separator is _ if no one has been provided.
        if (typeof (separator) === "undefined") {
            separator = "_";
        }

        // Cut the string into words
        var words = text.split(separator);

        // Concatenate all capitalized words to get camelized string
        var result = "";
        for (var i = 0; i < words.length; i++) {
            var word = words[i];
            var capitalizedWord = word.charAt(0).toUpperCase() + word.slice(1);
            result += capitalizedWord;
        }

        return result;
    },

    CreateUrl: function (fieldIdFrom, fieldIdTo) {
        $("#" + fieldIdFrom).change(function () {
            var url = $(this).val().replace(/\s+/g, '-').toLowerCase();
            if (!$("#" + fieldIdTo).val()) {
                $("#" + fieldIdTo).val(url);
            }
        });
    },

    CreateMetaDescription: function (fieldIdFrom, fieldIdTo) {
        $("#" + fieldIdFrom).change(function () {
            mmsystem.utilities.CloneFieldValue(fieldIdFrom, fieldIdTo);
        });
    },

    CreateMetaKeywords: function (fieldIdFrom, fieldIdTo) {
        $("#" + fieldIdFrom).change(function () {
            var keywords = $(this).val().replace(/\s+/g, ', ').toLowerCase();
            if (!$("#" + fieldIdTo).val()) {
                $("#" + fieldIdTo).val(keywords);
            }
        });
    },

    CreateSEOMetaTags: function (fieldIdFrom, fieldIdToDescr, fieldIdToKeywords ) {
        mmsystem.utilities.CreateMetaDescription(fieldIdFrom, fieldIdToDescr);
        mmsystem.utilities.CreateMetaKeywords(fieldIdFrom, fieldIdToKeywords);
    },

    CloneFieldValue: function (fieldIdFrom, fieldIdTo) {
        $("#" + fieldIdFrom).change(function () {
            //console.log("changed");
            var from = $(this).val();
            if (from !== $("#" + fieldIdTo).val()) {
                $("#" + fieldIdTo).val(from);
            }
        });
    },

    AlertPanel: function () {
        if ($(".alert").length) {
            $(".alert").delay(2000).fadeOut();
        }
    },

    SetBackgroundImagetoElement: function (element, imagePath) {
        if ($(element)) {
            $(element).css("background-image", "url(" + imagePath + ")");
        }
    },

    AdminLeftNavigationInit: function () {
        var ul = $(".admin-nav.nav-sidebar li.active").closest("ul.nav.collapse");
        var li = ul.closest("li");
        var a = li.find("a");
        a.click();
        li.closest("li").addClass("active");

        //Disable duplicates
        var duplicates = ul.find("li.active");
        if (duplicates.length > 1) {
            duplicates.each(function () {
                if ($(this).hasClass("active-index"))
                    $(this).removeClass("active");
            });
        }
    },

    GetGUID: function () {
        var guid = (mmsystem.utilities.GetRandomS4() + mmsystem.utilities.GetRandomS4() + "-" + mmsystem.utilities.GetRandomS4() + "-4" + mmsystem.utilities.GetRandomS4().substr(0, 3) + "-" + mmsystem.utilities.GetRandomS4() + "-" + mmsystem.utilities.GetRandomS4() + mmsystem.utilities.GetRandomS4() + mmsystem.utilities.GetRandomS4()).toLowerCase();
        return guid;
    },

    GetRandomS4: function () {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    },

    SetImageSource: function (element, url, useGuid) {
        if (useGuid)
            url = url + "?guid=" + mmsystem.utilities.GetGUID();
        $(element).attr('src', url);
    },

    ArraysEqual: function (_arr1, _arr2) {

        if (!Array.isArray(_arr1) || !Array.isArray(_arr2) || _arr1.length !== _arr2.length)
            return false;

        var arr1 = _arr1.concat().sort();
        var arr2 = _arr2.concat().sort();

        for (var i = 0; i < arr1.length; i++) {

            if (arr1[i] !== arr2[i])
                return false;

        }

        return true;

    },

    DecodeHtml: function (html) {
        var txt = document.createElement('textarea');
        txt.innerHTML = html;
        return JSON.parse(txt.value);
    }
};


//Node exports
module.exports = mmsystem.utilities;

// Hot Module Accept
if (module.hot) {
    module.hot.accept();
}